export default __webpack_public_path__ + "static/media/MrsJumokeAliBaba.45775d84.jpg";